export const COTACAO = () => `/cotacao`;
